import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../CSS/Global.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from './SideBar';
import { useSidebar } from '../SidebarContext';
import Header from './Header';

const Slider = () => {
    const { isSidebarOpen } = useSidebar();
    const [amenities, setAmenities] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [inputValuelink, setInputValuelink] = useState('');
    const [editIndex, setEditIndex] = useState(null);
    const [editData, setEditData] = useState({ name: "", image: "", link: "" });
    const [editValue, setEditValue] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const BASE_URL = "https://100real.xyz"; // Replace with your backend base URL

    useEffect(() => {
        fetchAmenities();
    }, []);

    // Fetch amenities from backend
    const fetchAmenities = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/slider/getslider/${isLoggedIn.user_id}`);
            setAmenities(response.data.reverse());
        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleInputChangeLink = (event) => {
        setInputValuelink(event.target.value);
    };

    const handleInputChange1 = (event) => {
        setEditData({ ...editData, name: event.target.value });
    };

    const handleInputChangeEdit = (event) => {
        setEditData({ ...editData, link: event.target.value });
    };
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleAddAmenities = async () => {
        if (!inputValue.trim()) {
            alert("Please enter amenity name");
            return;
        }

        const newAmenities = inputValue.split(',').map((amenity) => amenity.trim()).filter((amenity) => amenity !== '');

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('name', newAmenities[0]); // Assuming one amenity for now
        formData.append('status', 'active');
        formData.append('link', inputValuelink);
        formData.append('user_id', isLoggedIn.user_id);
        if (selectedFile) {
            formData.append('image', selectedFile);
        }

        try {
            const response = await axios.post(`${BASE_URL}/slider/add-slider/igothousifyu`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            console.log(response)
            if (response.status === 200) {
                toast.success('New Slider Added');
                fetchAmenities();
                setInputValue('');
                setIsModalOpen(false);
                setSelectedFile(null);
            }

        } catch (error) {
            console.error('Error adding slider:', error);
            toast.error(error);
        }
    };

    const handleEditChange = (event) => {
        setEditValue(event.target.value);
    };

    const handleEdit = (index) => {
        const slider = amenities[index];
        setEditIndex(index);
        setEditData({ name: slider.name, image: slider.image, link: slider.link });
        setIsEditMode(true);
        setIsModalOpen1(true);
    };

    const handleUpdateSlider = async () => {
        const slider = amenities[editIndex];
        const formData = new FormData();
        formData.append("name", editData.name);
        formData.append("link", editData.link);
        if (selectedFile) {
            formData.append("image", selectedFile);
        }

        try {
            let response = await axios.put(`${BASE_URL}/slider/change-slider/${slider.id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (response.status === 200) {
                toast.success('Slider Updated');
                fetchAmenities();
                closeModal1();
            }

        } catch (error) {
            toast.error(error);
            console.error("Error updating slider:", error);
        }
    };
    // const handleEdit = (index) => {
    //     const slider = sliders[index];
    //     setEditIndex(index);
    //     setEditData({ name: slider.name, image: slider.image });
    //     setIsEditMode(true);
    //     setIsModalOpen(true);
    //   };

    const handleDelete = async (index) => {
        const amenity = amenities[index];
        try {
            const response = await axios.delete(`${BASE_URL}/slider/delete-slider/${amenity.id}`);
            if (response.status === 200) {
                toast.success('Slider Deleted');
                fetchAmenities();
            }

        } catch (error) {
            toast.error(error);
            console.error('Error deleting amenity:', error);
        }
    };

    const handleToggleStatus = async (index) => {
        const amenity = amenities[index];
        const updatedStatus = amenity.status === 'active' ? 'inactive' : 'active';

        try {
            await axios.put(`${BASE_URL}/amenities/change/${amenity.id}`, { status: updatedStatus });
            fetchAmenities();
        } catch (error) {
            console.error('Error toggling status:', error);
        }
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const openModal1 = () => {
        setIsModalOpen1(true);
    };

    const closeModal1 = () => {
        setIsModalOpen1(false);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = amenities.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(amenities.length / itemsPerPage);

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Our Slider</h1>

                    <button className="oms-add-btn" onClick={openModal}>
                        Add Slider
                    </button>
                </div>
                <div className="amenities-container">
                    {/* <div className="amenities-header">
                    <h1>Our Slider</h1>
                    <div className="add-btn">
                        <button className="add-btn" onClick={openModal}>
                            Add Slider
                        </button>
                    </div>
                </div> */}

                    {/* Modal for adding amenities */}
                    {isModalOpen && (
                        <div className="modal">
                            <div className="modal-content">
                                <h2>Add Slider</h2>
                                <input
                                    type="text"
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    placeholder="Enter Title"
                                />

                                <input
                                    type="text"
                                    value={inputValuelink}
                                    onChange={handleInputChangeLink}
                                    placeholder="Enter Link"
                                />
                                <input type="file" onChange={handleFileChange} required />
                                <div className="modal-actions">
                                    <button onClick={handleAddAmenities}>Add</button>
                                    <button onClick={closeModal}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {isModalOpen1 && (
                        <div className="modal">
                            <div className="modal-content">
                                <h2>Edit Slider</h2>
                                <input
                                    type="text"
                                    value={editData.name}
                                    onChange={handleInputChange1}
                                    placeholder="Enter Title"
                                />
                                <div>
                                    {/* <p>Current Image:</p> */}
                                    <img
                                        className="slider-preview"
                                        src={`${BASE_URL}/${editData.image}`}
                                        alt="Current Slider"
                                    />
                                </div>

                                <input
                                    type="text"
                                    value={editData.link}
                                    onChange={handleInputChangeEdit}
                                    placeholder="Enter Link"
                                />
                                <input type="file" onChange={handleFileChange} required />
                                <div className="modal-actions">
                                    <button onClick={handleUpdateSlider}>Add</button>
                                    <button onClick={closeModal1}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Amenities Table */}
                    <div className="amenities-table">
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((amenity, index) => {
                                        const actualIndex = indexOfFirstItem + index;
                                        return <tr key={index}>
                                            <td><img className='sliderimg' src={`https://100billionoms.com/${amenity.image}`} alt="" /></td>
                                            <td>

                                                {amenity.name}

                                            </td>
                                            <td>
                                                <span className={amenity.status}>
                                                    {amenity.status.charAt(0).toUpperCase() + amenity.status.slice(1)}
                                                </span>
                                            </td>
                                            <td>

                                                <>
                                                    {/* <button onClick={() => handleToggleStatus(index)}>
                                                    <i className={`fa ${amenity.status === 'active' ? 'fa-toggle-on' : 'fa-toggle-off'}`} />
                                                </button> */}
                                                    <button onClick={() => handleEdit(actualIndex)}>
                                                        <i className="fa fa-edit" />
                                                    </button>
                                                    <button onClick={() => handleDelete(index)}>
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                </>

                                            </td>
                                        </tr>
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="4">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="pagination-container">
                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                            >
                                ◀ Prev
                            </button>

                            <span className="pagination-current">Page {currentPage} of {totalPages}</span>

                            <button
                                className="pagination-button"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                            >
                                Next ▶
                            </button>
                        </div>
                    </div>
                    {/* <ToastContainer /> */}
                </div>
            </div >
        </>
    );
};

export default Slider;
